import { Button, Dropdown, Icon, Menu } from '@oscar/theme';
import { REQUEST_STATUS } from 'common/constants';
import { APIS } from 'common/constants/endpoints';
import { REQUEST_TYPE } from 'common/constants/insulation';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Popup from '../Popup';

// Items Action Button
const menuBtnActionItems = (
  showHideMenmuItem: any,
  status: any,
  handleShowPop: any,
) => {
  // console.log(REQUEST_STATUS.CLOSED.VALUE);
  // console.log(showHideMenmuItem.canSendBackAdmin);
  return (
    <Menu onClick={handleShowPop}>
      {((showHideMenmuItem.canEditDraf &&
        status === REQUEST_STATUS.DRAFT.VALUE) ||
        (showHideMenmuItem.canEditValidation &&
          status === REQUEST_STATUS.PENDING_VALIDTION.VALUE)) && (
        <Menu.Item key="action-edit">Edit</Menu.Item>
      )}
      {((showHideMenmuItem.canCancelDraf &&
        status === REQUEST_STATUS.DRAFT.VALUE) ||
        (showHideMenmuItem.canCancelValidation &&
          status === REQUEST_STATUS.PENDING_VALIDTION.VALUE) ||
        (showHideMenmuItem.canCancelProposal &&
          status === REQUEST_STATUS.PENDING_PROPOSAL.VALUE) ||
        (showHideMenmuItem.canCancelRemoval &&
          status === REQUEST_STATUS.PENDING_REMOVAL.VALUE) ||
        (showHideMenmuItem.canCancelReinstatement &&
          status === REQUEST_STATUS.PENDING_REINSTATEMENT.VALUE) ||
        (showHideMenmuItem.canCancelReinstatement &&
          status === REQUEST_STATUS.PENDING_PAINTING.VALUE) ||
        (showHideMenmuItem.canCancelPendingqaqc &&
          status === REQUEST_STATUS.PENDING_REINSTATEMENT.VALUE) ||
        (showHideMenmuItem.canCancelQAQC &&
          status === REQUEST_STATUS.PENDING_QAQC.VALUE) ||
        (showHideMenmuItem.canCancelPendingPainting &&
          status === REQUEST_STATUS.PENDING_PAINTING.VALUE)) && (
        <Menu.Item key="action-cancel">Cancel</Menu.Item>
      )}
      {((showHideMenmuItem.canSendBackRemoval &&
        status === REQUEST_STATUS.PENDING_REMOVAL.VALUE) ||
        (showHideMenmuItem.canSendBackReinstatement &&
          status === REQUEST_STATUS.PENDING_REINSTATEMENT.VALUE)) && (
        <Menu.Item key="action-sendback">Send Back</Menu.Item>
      )}
      {showHideMenmuItem.canSendBackPendingproposal &&
        status === REQUEST_STATUS.PENDING_PROPOSAL.VALUE && (
          <Menu.Item key="action-sendback-contractor">Send Back</Menu.Item>
        )}
      {showHideMenmuItem.canSendBackAdmin &&
        status === REQUEST_STATUS.CLOSED.VALUE && (
          <Menu.Item key="action-sendback-admin">Send Back</Menu.Item>
        )}
      {((showHideMenmuItem.canRejectedValidation &&
        status === REQUEST_STATUS.PENDING_VALIDTION.VALUE) ||
        (showHideMenmuItem.canRrejectedProposal &&
          status === REQUEST_STATUS.PENDING_PROPOSAL.VALUE)) && (
        <Menu.Item key="action-reject">Reject</Menu.Item>
      )}
      {showHideMenmuItem.canCompletedInservice &&
        status === REQUEST_STATUS.IN_SERVICE.VALUE && (
          <Menu.Item key="action-cwc">Confirm Work Completed</Menu.Item>
        )}
      {showHideMenmuItem.canClosedBilling &&
        status === REQUEST_STATUS.BILLING.VALUE && (
          <Menu.Item key="action-close">Close</Menu.Item>
        )}
    </Menu>
  );
};

function ActionButtonTable(props: any) {
  const { record, roleButton, actionProps } = props;
  const navigate = useNavigate();
  const [statusRequestPopup, setStatusRequestPopup] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [titlePopup, setTitlePopup] = useState('');
  const [description, setDescription] = useState('');
  const [tittleContent, setTittleContent] = useState('');
  const [requireContent, setRequireContent] = useState(false);
  const [hintTextArea, setHintTextArea] = useState('');

  let disabledActionButton = true;
  for (const role of roleButton?.role) {
    // console.log(role);
    if (
      (role === 'OSCAR' &&
        !(
          record?.requestId.slice(0, 3).toLowerCase() === 'ins' &&
          REQUEST_STATUS.PENDING_QAQC.VALUE === record?.status
        ) &&
        [
          REQUEST_STATUS.DRAFT.VALUE,
          REQUEST_STATUS.PENDING_VALIDTION.VALUE,
          REQUEST_STATUS.PENDING_PROPOSAL.VALUE,
          REQUEST_STATUS.PENDING_REMOVAL.VALUE,
          REQUEST_STATUS.PENDING_REINSTATEMENT.VALUE,
          REQUEST_STATUS.IN_SERVICE.VALUE,
          REQUEST_STATUS.PENDING_QAQC.VALUE,
          REQUEST_STATUS.PENDING_PAINTING.VALUE,
        ].findIndex(elem => elem === record?.status) !== -1) ||
      ((role === 'INSULATION' || role === 'PAINTING') &&
        [
          REQUEST_STATUS.PENDING_VALIDTION.VALUE,
          REQUEST_STATUS.BILLING.VALUE,
          REQUEST_STATUS.PENDING_REINSTATEMENT.VALUE,
          REQUEST_STATUS.PENDING_REMOVAL.VALUE,
          REQUEST_STATUS.PENDING_PROPOSAL.VALUE,
        ].findIndex(elem => elem === record?.status) !== -1) ||
      (role === 'CONTRACTOR' &&
        [REQUEST_STATUS.PENDING_PROPOSAL.VALUE].findIndex(
          elem => elem === record?.status,
        ) !== -1) ||
      (role === 'ADMIN' &&
        [REQUEST_STATUS.CLOSED.VALUE].findIndex(
          elem => elem === record?.status,
        ) !== -1)
    ) {
      disabledActionButton = false;
      break;
    }
  }

  const handleShowPop = (e: any) => {
    switch (e.key) {
      case 'action-edit':
        {
          navigate(
            `/insulation/edit/${record?.requestId}?type=${
              Object.values(REQUEST_TYPE)?.[record?.service - 1]
            }`,
          );
        }
        break;
      case 'action-cancel':
        {
          setTitlePopup('Cancel confirmation');
          setDescription('Are you sure you want to cancel this request?');
          setTittleContent('Remarks');
          setHintTextArea('Please write the reason to cancel the request');
          setRequireContent(true);
        }
        setStatusRequestPopup('cancel');
        setShowPopup(true);
        break;
      case 'action-sendback':
        {
          setTitlePopup('SendBack confirmation');
          setDescription('Are you sure you want to Send Back this request?');
          setTittleContent('Remarks');
          setHintTextArea('Please write the reason to Send Back the request');
          setRequireContent(true);
        }
        setStatusRequestPopup('sendback');
        setShowPopup(true);
        break;
      case 'action-sendback-contractor':
        {
          setTitlePopup('SendBack confirmation');
          setDescription('Are you sure you want to Send Back this request?');
          setTittleContent('Remarks');
          setHintTextArea('Please write the reason to Send Back the request');
          setRequireContent(true);
        }
        setStatusRequestPopup('sendback-contractor');
        setShowPopup(true);
        break;
      case 'action-sendback-admin':
        {
          setTitlePopup('SendBack confirmation');
          setDescription('Are you sure you want to Send Back this request?');
          setTittleContent('Remarks');
          setHintTextArea('Please write the reason to Send Back the request');
          setRequireContent(true);
        }
        setStatusRequestPopup('sendback-admin');
        setShowPopup(true);
        break;
      case 'sendback-contractor-qaqc':
        {
          setTitlePopup('SendBack confirmation');
          setDescription('Are you sure you want to Send Back this request?');
          setTittleContent('Remarks');
          setHintTextArea('Please write the reason to Send Back the request');
          setRequireContent(true);
        }
        setStatusRequestPopup('sendback-contractor-qaqc');
        setShowPopup(true);
        break;
      case 'action-reject':
        {
          setTitlePopup('Reject confirmation');
          setDescription('Are you sure you want to reject this request?');
          setTittleContent('Remarks');
          setHintTextArea('Please write the reason to reject the request');
          setRequireContent(true);
        }
        setStatusRequestPopup('reject');
        setShowPopup(true);
        break;
      case 'action-cwc':
        {
          actionProps.doAction({
            name: 'submit',
            url: APIS.COMPLETE_REQUEST,
            method: 'POST',
            params: {
              id: record?.id,
            },
          });
        }
        break;
      case 'action-close':
        {
          actionProps.doAction({
            name: 'submit',
            url: APIS.CLOSE_REQUEST,
            method: 'POST',
            params: {
              id: record?.id,
            },
          });
        }
        break;
    }
  };

  const handleConfirmSubmit = (remarkText: any) => {
    let urlApi = '';
    setShowPopup(false);
    if (statusRequestPopup === 'reject') {
      urlApi = APIS.REJECT_REQUEST;
    } else if (statusRequestPopup === 'cancel') urlApi = APIS.CANCELD_REQUEST;
    else if (statusRequestPopup === 'sendback-contractor')
      urlApi = APIS.SENDBACK_REQUEST_CONTRACTOR;
    else if (statusRequestPopup === 'sendback-contractor-qaqc')
      urlApi = APIS.SENDBACK_REQUEST_CONTRACTOR_QAQC;
    else if (statusRequestPopup === 'sendback-admin')
      urlApi = APIS.SENDBACK_REQUEST_ADMIN;
    else {
      if (statusRequestPopup === 'sendback') urlApi = APIS.SENDBACK_REQUEST;
    }
    actionProps.doAction({
      name: 'submit',
      url: urlApi,
      method: 'POST',
      data: {
        id: record?.id,
        remarks: remarkText,
      },
    });
  };

  const handleCancelSubmit = () => {
    setShowPopup(false);
  };

  return (
    <>
      <Dropdown
        overlay={menuBtnActionItems(
          roleButton?.showHideMenmuItem,
          record?.status,
          handleShowPop,
        )}
        placement="bottomRight"
        trigger={['click']}
        disabled={disabledActionButton}
      >
        <Button>
          Action&ensp;
          <Icon icon="arrow-down" size={8} />
        </Button>
      </Dropdown>

      <Popup
        title={titlePopup}
        isVisible={showPopup}
        handleOk={handleConfirmSubmit}
        handleCancel={handleCancelSubmit}
        description={description}
        tittleContent={tittleContent}
        requireContent={requireContent}
        hintTextArea={hintTextArea}
      />
    </>
  );
}

export default ActionButtonTable;
